import { useCallback } from "react";
import { InsufficientInfo } from "../../ChartMessages/InsufficientInfo";
import { useNavigate, useParams } from "react-router-dom";

interface Props {
  isForTable?: boolean;
  isForWhitespace?: boolean;
}

export function InsufficientInfoWrapper(props: Props) {
  const navigate = useNavigate();
  const { id: workspaceId } = useParams();

  const onInsufficientInfoClick = useCallback(() => {
    const tab = props.isForWhitespace ? "whitespace" : "competitors";
    navigate(`/projects/${workspaceId}/configuration/${tab}`);
  }, [navigate, workspaceId, props.isForWhitespace]);

  return <InsufficientInfo onClick={onInsufficientInfoClick} {...props} />;
}
